import { useEffect, useState } from 'react';
import { storeService } from '../services/storeService';
import { StoreCatalogItem } from '../models';

const BEST_SELLERS_PAGE_SIZE = 8;

export function useBestSellers(enabled: boolean) {
  const [items, setItems] = useState<StoreCatalogItem[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!enabled) return;

    let active = true;
    setIsLoading(true);
    setError(null);

    storeService
      .getCatalog({
        pageNumber: 1,
        pageSize: BEST_SELLERS_PAGE_SIZE,
        sortBy: 'bestseller',
      })
      .then((data) => {
        if (active) setItems(data.items);
      })
      .catch((err) => {
        if (active) setError(err instanceof Error ? err : new Error('Erro ao carregar mais vendidos'));
      })
      .finally(() => {
        if (active) setIsLoading(false);
      });

    return () => {
      active = false;
    };
  }, [enabled]);

  return { items, isLoading, error, isEmpty: items.length === 0 };
}
